import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    monthlyBudgetCap: 50,
    freeCreditsMonthlyBudget: 200,
    mapDemo: false
};

const launchConfigSlice = createSlice({
    name: 'launchConfig',
    initialState,
    reducers: {
        setLaunchConfig: (state, action) => {
            state.monthlyBudgetCap = action.payload.monthlyBudgetCap;
            state.freeCreditsMonthlyBudget = action.payload.freeCreditsMonthlyBudget;
            state.mapDemo = action.payload.mapDemo;
        },
    },
});

export const { setLaunchConfig } = launchConfigSlice.actions
export default launchConfigSlice.reducer
